module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-exclamation-ed9b9375.svg";